import type { LocationSource } from '@/contexts/FilterContext';

interface LocationSEO {
  title: string;
  description: string;
  canonicalPath: string | undefined;
}

/**
 * Generate location-aware SEO metadata.
 * When on a city page, swaps "Near You" for "in {label}" and omits
 * canonicalPath so the parent LocationPage's canonical is used.
 */
export function getLocationSEO(
  baseTitle: string,
  baseDescription: string,
  canonicalPath: string,
  locationLabel: string | null,
  locationSource: LocationSource
): LocationSEO {
  const isCity = locationSource === 'city' && !!locationLabel;

  if (isCity) {
    return {
      title: baseTitle.replace(/Near You$/i, `in ${locationLabel}`),
      description: baseDescription.replace(/near you/gi, `in ${locationLabel}`),
      canonicalPath: undefined,
    };
  }

  return { title: baseTitle, description: baseDescription, canonicalPath };
}
